module.exports = __webpack_public_path__ + "img/chicos-web.4cb003ad.webp";